import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { isFutureContract } from "@rentiohq/shared-frontend/dist/utils/contract.utils";
import {
  EField,
  ELocationDescriptionType,
  IExtraData,
} from "./schema.orderLocationDescription.types";

export const getInitialValues = (extraData: IExtraData): IValues => {
  const { currentContract, type } = extraData;

  return {
    // Preselect the report type based on the flow it was opened from:
    // entry flow -> "in", exit flow -> "out". Fall back to the legacy default
    // (Both for future MEXP contracts, otherwise Out) when no flow is given.
    [EField.LocationDescriptionType]:
      type ??
      (isFutureContract(currentContract) &&
      extraData.partnership.locationDescriptorKey?.includes("MEXP")
        ? ELocationDescriptionType.Both
        : ELocationDescriptionType.Out),
    [EField.Contract]: currentContract.id,
    [EField.PeopleGetKeys]: "",
    [EField.ApartmentIsEmpty]: "",
  };
};
